/* global chrome */
import React, {useState, useContext, useEffect} from 'react';
import {Link, withRouter} from 'react-router-dom';
import authApi from '../services/api/auth';
import {GlobalContext} from "../context/GlobalState";
import "../styles/auth.scss";
import Logo from '../images/logo-full.svg';
import EmailIcon from '../images/icons/email-icon.svg';
import PasswordIcon from '../images/icons/password-icon.svg';
import SVG from 'react-inlinesvg';
import SponsoredChannels from '../components/SponsoredChannels';
import ReactGA from 'react-ga';

const PasswordUpdate = ({history}) => {
  const params = new URLSearchParams(window.location.search);
  const {logIn, userData} = useContext(GlobalContext);
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [token, setToken] = useState('');
  const [error, setError] = useState('');
  const queryToken = params.get('token');
  const queryEmail = params.get('email');

  useEffect(() => {
    setToken(queryToken);
    setEmail(queryEmail);
  });

  if (userData && userData.accountLevel) {
    history.push('/home');
  }

  const updateEmail = e => {
    setEmail(e.target.value);
  };

  const updatePassword = e => {
    setPassword(e.target.value);
  };

  const handleUpdatePasswordAndLogIn = async e => {
    e.preventDefault();
    try {
      const data = {
        password,
        token,
      };

      const {data: userData} = await authApi.updatePasswordAndLogIn(data);

      ReactGA.event({
        category: 'User',
        action: 'Updated Password With Token',
      });

      logIn({userData});

      const extensionId = "hemjflepggljigpcaneoeldgipbpcbmg";

      if (chrome) {
        chrome.runtime.sendMessage(extensionId, {type: 'autoLogin', token: userData.loginToken});
      }

      history.push('/home');

    } catch (error) {
      if (typeof error.response.data === 'string') {
        console.log('ERROR:', error.response.data);
        setError(error.response.data);
      } else {
        console.log('ERROR:', error);
        setError('Please enter a valid email and password and try again.');
      }
    }
  };

  return (
    <div className="auth-container signup">
      <SponsoredChannels />

      <div className="form">
        <div className="logo-container">
          <img src={Logo} alt="logo"/>
        </div>
        <h1>Update Password</h1>
        <p className="login-link">Did you remember it? <Link to='/login'>Log in</Link></p>
        {error && <p className="error">{error}</p>}
        <form>
          <div className="input-wrapper">
            <input value={email} onChange={updateEmail} placeholder='Email' type='email' required/>
            <SVG src={EmailIcon}/>
          </div>
          <div className="input-wrapper">
            <input value={password} onChange={updatePassword} placeholder='New Password' type='password' required/>
            <SVG src={PasswordIcon} />
          </div>
          <button onClick={handleUpdatePasswordAndLogIn} className="button-primary wide">Update password and log in</button>
        </form>
        <div className="copyright">

        </div>
      </div>
    </div>
  );
};

export default withRouter(PasswordUpdate);
